import React, { Component } from 'react';
import {connect} from 'react-redux';
import {ItemsActions} from "../../actions/items.actions";
import ItemForm from "./ItemForm";
import {
    EditingState,
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table,
    TableHeaderRow,
    TableGroupRow,
    TableEditRow,
    TableEditColumn,
} from '@devexpress/dx-react-grid-material-ui';
import {
    IntegratedSorting, SortingState, PagingState, IntegratedPaging,
    GroupingState, IntegratedGrouping, DataTypeProvider
} from '@devexpress/dx-react-grid';
import {Paper} from "material-ui";
import {withRouter} from 'react-router-dom';
import ReactGA from 'react-ga';

const CurrencyFormatter = ({ value }) =>
    <b style={{ color: 'darkblue' }}>{Intl.NumberFormat('fr-FR').format(value)} PO</b>;

const CurrencyTypeProvider = props => (
    <DataTypeProvider
        formatterComponent={CurrencyFormatter}
        {...props}
    />
);

const getRowId = row => row.id;


class Items extends Component {

    componentDidMount(){
        ReactGA.pageview(window.location.pathname + window.location.search);
        this.props.dispatch(ItemsActions.fetch());
    }

    submitItem = (values) => {
        this.props.dispatch(ItemsActions.create(values));
    };

    renderEquipmentName = (row) => {
        const {name} = row;
        switch(row.category){
            case '1hand':
                return `Épée à 1 main ${name}`;
            case '2hand':
                return `Épée à 2 mains ${name}`;
            case 'chest':
                return `Armure ${name}`;
            case 'helm':
                return `Casque ${name}`;
            case 'shield':
                return `Bouclier ${name}`;
            default:
                return `${row.category} ${name}`;
        }
    };

    renderGroupName = (value) => {
        const { items }= this.props;
        let family = items.filter(i => i.name === value);
        let levels = [];
        family.map(f => {
            levels.push(f.required_lvl)
        });
        let min = Math.min(...levels);
        let max = Math.max(...levels);
        return {
            value:`${value} (${min} à ${max})`,
            key: value
        }
    };

    renderCell = props => {
        if(props.column.name === 'category') {
            return <Table.Cell
                value={this.renderEquipmentName(props.row)}
            />;
        } else if(props.column.name === 'name'){
            return <Table.Cell
                value={"eazdzadzad"}
            />
        } {
            return <Table.Cell {...props} />
        }
    };

    commitChanges = ({ added, changed, deleted }) => {
        const {items} = this.props;
        if(changed){
            // TODO get item in array and overwrite with new values
            let itemToEdit = items.find(i => i.id === Object.keys(changed)[0]);
            let editedObject = changed[Object.keys(changed)[0]];
            if(editedObject){
                Object.keys(editedObject).map(v => {
                    itemToEdit[v] = editedObject[v];
                });
                this.props.dispatch(ItemsActions.edit(itemToEdit));
            }
        }
        if(deleted){
            this.props.dispatch(ItemsActions.delete(deleted[0]))
        }
    };

    render(){
        const {user} = this.props;
        return (
            <div>
                {user && user.isAdmin &&
                    <ItemForm onSubmit={this.submitItem}/>
                }
                {!this.props.fetchItems &&
                <Paper elevation={4} style={{padding: '16px', marginTop: '16px'}}>
                    <h3>Equipements</h3>
                    <p>Retrouvez la liste des équipements disponibles chez les commerçants ainsi que leur localisation. Cliquez
                    sur une famille d'équipements pour voir les détails.</p>
                    <Grid
                        rows={this.props.items}
                        columns={[
                            { name: 'name', title: 'Nom de l\'équipement' },
                            { name: 'category', title: 'Type' },
                            { name: 'price', title: 'Prix' },
                            { name: 'location', tilte: 'Localisation'},
                            { name: 'required_lvl', title: 'Niveau requis'},
                            {name: 'strength_required', title: 'Force requise'},
                            {name: 'dexterity_required', title: 'Dextérité requise'},
                            {name: 'armor_required', title: 'Constitution requise'},
                        ]}
                        getRowId={getRowId}
                    >
                        {user && user.isAdmin &&
                        <EditingState
                            onCommitChanges={this.commitChanges}
                        />
                        }
                        <CurrencyTypeProvider
                            for={['price']}
                        />
                        <SortingState
                            defaultSorting={[
                                { columnName: 'required_lvl', direction: 'desc' }
                            ]}
                        />
                        <GroupingState
                            grouping={[{columnName: 'name'}]}
                        />
                        <PagingState
                            defaultCurrentPage={0}
                            defaultPageSize={20}
                        />
                        <IntegratedSorting />
                        <IntegratedGrouping
                            columnExtensions={[
                                {columnName: 'name', criteria: this.renderGroupName}
                            ]}
                        />
                        <IntegratedPaging />
                        <Table
                            cellComponent={this.renderCell}
                        />
                        <TableHeaderRow showSortingControls/>
                        {user && user.isAdmin &&
                        <div>
                            <TableEditRow />
                            <TableEditColumn
                                showDeleteCommand
                                showEditCommand
                            />
                        </div>
                        }

                        <TableGroupRow />
                    </Grid>
                </Paper>
                }
            </div>
        )
    }
};

function state2props(state) {
    return {
        fetchItems: state.Items.fetchItems,
        items: state.Items.items,
        user: state.User.user
    }
}

export default withRouter(connect(state2props)(Items));


// WEBPACK FOOTER //
// ./src/pages/items/Items.js